import useCalenderFilter from "../../../hooks/useCalenderFilter";
import {
  Box,
  Button,
  List,
  ListItem,
  Menu,
  MenuItem,
  Stack,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "../../../styles/pages/home.module.scss";
import styles1 from "../../../styles/pages/partnerTable.module.scss";
import dayjs from "dayjs";
// import Image from "next/image";
import assest from "../../../json/assest";
import { DatePicker } from "@imarabinda/antd";
import { convertDayJsToDateRange } from "../../../lib/functions/utils.lib";
import CalenderDate from "../../../pages/Calender";

const { RangePicker } = DatePicker;

// export type FilterRowProps = {
//   hideFilter?: boolean;
//   hideCalender?: boolean;
//   hideDateRangeFilter?: boolean;
//   hideSearch?: boolean;
//   hideLastItem?: boolean;
//   children?: React.ReactNode;
//   rightItems?: React.ReactNode;
//   leftItems?: React.ReactNode;
//   middleItems?: React.ReactNode;
//   FilterModalComponent?: React.JSXElementConstructor<{
//     open: boolean;
//     onClose: () => void;
//   }>;
//   filterModalProps?: React.ComponentProps<any>;
// };
export default function PartnerRejectedFilter({
  hideFilter,
  children,
  hideLastItem,
  hideCalender,
  hideDateRangeFilter,
  rightItems,
  leftItems,
  middleItems,
  hideSearch,
  FilterModalComponent,
  filterModalProps,
  handleDateChange,
  handleAwaitingConfirmation,
  handleSearchStringChange,
}) {
  const calenderContainerId = "calender-input-filter-row";
  const calenderId = "calendar-input-home";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    calenderOpen,
    resetCalender,
    confirmCalender,
    confirmedCalenderValue,
    calenderValue,
    setCalenderValue,
    toggleCalender,
    closeCalender,
    confirmCalenderTwo,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderId,
  });

  const [clearBtn, setclearBtn] = useState(false);
  const [inputValue, setinputValue] = useState("");

  const handleInput = (event) => {
    setinputValue(event.target.value);
  };
  // search string
  useEffect(() => {
    handleSearchStringChange(inputValue);

    if (inputValue.length > 0) {
      setclearBtn(true);
    } else if (inputValue.length === 0) {
      setclearBtn(false);
    }
  }, [inputValue]);
  // search string

  const [openFilterModal, setOpenFilterModal] = useState(false);
  const handleOpenFilterModal = useCallback(() => {
    setOpenFilterModal(true);
  }, []);
  const handleCloseFilterModal = useCallback(() => {
    setOpenFilterModal(false);
  }, []);

  useEffect(() => {
    if (confirmedCalenderValue?.length === 2) {
      const convertedDates = convertDayJsToDateRange(confirmedCalenderValue);
      handleDateChange(convertedDates);
    }
  }, [confirmedCalenderValue]);
  return (
    <>
      {FilterModalComponent ? (
        <FilterModalComponent
          {...filterModalProps}
          open={openFilterModal}
          onClose={handleCloseFilterModal}
        />
      ) : null}
      {!hideDateRangeFilter ? (
        <Box className={`${styles.table_left2} ${styles1.tableLeftPartner}`}>
          {leftItems}
          <Box className="commonSearchBar_modal">
            <p>
              Showing videos for{" "}
              {calenderFilter ? (
                <>
                  <Box
                    className={`dayList ${
                      openedDateRangeFilter ? "date-black" : "date-blue"
                    }`}
                  >
                    <Button
                      aria-haspopup="true"
                      onClick={handleOpenDateRangeFilter}
                    >
                      {calenderFilter?.name}
                    </Button>
                    <Menu
                      anchorEl={dateRangeFilterAnchor}
                      open={openedDateRangeFilter}
                      onClose={handleCloseDateRangeFilter}
                      className="dateList"
                    >
                      {DateFilterRangeList.slice(1).map((filter) => (
                        <MenuItem
                          onClick={changeCalenderFilter(filter)}
                          key={filter.name}
                          selected={filter === calenderFilter}
                        >
                          {filter.name}
                        </MenuItem>
                      ))}
                    </Menu>
                  </Box>
                  <span className="dateList">({calenderFilterShowValue})</span>
                </>
              ) : (
                <>
                  the period from{" "}
                  {confirmedCalenderValue?.[0] ? (
                    <span className="dayList">
                      {dayjs(confirmedCalenderValue?.[0]).format("LL")}
                    </span>
                  ) : null}{" "}
                  to{" "}
                  {calenderValue?.[1] ? (
                    <span className="dayList">
                      {dayjs(confirmedCalenderValue?.[1]).format("LL")}
                    </span>
                  ) : null}
                </>
              )}
            </p>
            {calenderFilter?.name !== "Today" ? (
              <span className="reset_picker" onClick={resetCalender}>
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M4.22705 6.7832L6.77263 4.23762"
                    stroke="currentColor"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M6.77263 6.76238L4.22705 4.2168"
                    stroke="currentColor"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                reset
              </span>
            ) : null}
          </Box>
        </Box>
      ) : null}

      <Box
        className={`${styles.table_middle} ${styles1.tableMiddlePartner} ${styles1.table_middle_cmn_struct}`}
      >
        {middleItems}
        {!hideSearch ? (
          <Box className={styles.table_search}>
            <Box
              className={`${styles.input_container} ${styles.input2} ${styles1.partnerApproveInput}`}
            >
              <input
                type="text"
                placeholder="Enter an email address, submitter name, VSID to search..."
                value={inputValue}
                onChange={handleInput}
                className={styles1.inputemails}
              />
              {clearBtn && (
                <Button
                  className={styles1.clearBtn}
                  onClick={() => setinputValue("")}
                >
                  Clear
                </Button>
              )}
            </Box>
          </Box>
        ) : null}
      </Box>

      <Box className={`${styles.table_right} ${styles.tableRightPartner}`}>
        <Button
          className={styles.awaitingBtn}
          onClick={handleAwaitingConfirmation}
        >
          Awaiting Confirmation
        </Button>
        <List>
          {!hideFilter ? (
            <ListItem className={styles.table_filter}>
              <a href="#" onClick={handleOpenFilterModal}>
                <img
                  src={assest.filterIconBlack}
                  width={14}
                  height={16}
                  alt=""
                />
              </a>
            </ListItem>
          ) : null}

          {/* {!hideCalender ? (
            <div
              id={calenderContainerId}
              style={{
                opacity: 0,
                visibility: "hidden",
                position: "absolute",
                right: "5%",
              }}
            >
              <RangePicker
                value={calenderValue}
                open={calenderOpen}
                onCalendarChange={(val) => {
                  setCalenderValue(val);
                }}
                renderExtraFooter={() => (
                  <Stack direction="row" justifyContent={"flex-end"}>
                    <Button onClick={closeCalender}>Cancel</Button>
                    <Button onClick={confirmCalender} className="active">
                      Confirm
                    </Button>
                  </Stack>
                )}
              />
            </div>
          ) : null}

          {!hideCalender ? (
            <ListItem className={styles.table_filter}>
              <a href="#" onClick={toggleCalender}>
                <img
                  src={assest.calendar_black}
                  width={14}
                  height={16}
                  alt=""
                />
              </a>
            </ListItem>
          ) : null} */}

          <CalenderDate confirmCalender={confirmCalenderTwo} />
          {/* {!hideLastItem ? (
            <ListItem className={styles.table_video_button}>
              <Button>
                All videos: <span>278</span>
              </Button>
            </ListItem>
          ) : null} */}
        </List>
        {rightItems}
      </Box>
      {children}
    </>
  );
}
